// utils
import PadEditorPrescriptionProcedure from '../components-js/pad-prescription/PadPrescriptionProcedure';

const TEMPLATE_NAME = 'PAD_EDITOR_PRESCRIPTION_PROCEDURE';

const initialState = {
  errors: [],
  data: {
    current: [],
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      return padEditorPrescription.setLoading(true).setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { currentPadPrescriptionProcedure, previousPadPrescriptionProcedure } = action.payload;

      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      return padEditorPrescription
        .prepare(currentPadPrescriptionProcedure, previousPadPrescriptionProcedure)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      return padEditorPrescription.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const prescriptionForm = action.payload;
      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      // prettier-ignore
      return padEditorPrescription
        .add(prescriptionForm)
        .replacesAllPrescriptors(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      return padEditorPrescription
        .edit(code, prescriptionForm)
        .replacesAllPrescriptors(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const prescription = action.payload.data;
      const { code } = prescription;
      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      return padEditorPrescription.remove(code).getState();
    }

    case `${TEMPLATE_NAME}_SUSPEND`: {
      const prescription = action.payload.data;
      const { code } = prescription;
      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      // prettier-ignore
      return padEditorPrescription
        .suspend(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_UNSUSPEND`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padEditorPrescription = new PadEditorPrescriptionProcedure(state);

      // prettier-ignore
      return padEditorPrescription
        .unsuspend(code, prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_CHANGE_STATUS`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadEditorPrescriptionProcedure(state);

      // prettier-ignore
      return padCreatorPrescription
        .changeStatus(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
